import axios from 'axios';

const SAFE_METHODS = ['get', 'head', 'options', 'trace'];

export const getCsrfToken = () => {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const csrfHeaders = () => {
  const token = getCsrfToken();
  return token ? { 'X-CSRF-Token': token } : {};
};

export const installCsrfInterceptor = () => {
  axios.interceptors.request.use((config) => {
    if (!SAFE_METHODS.includes((config.method || 'get').toLowerCase())) {
      Object.assign(config.headers, csrfHeaders());
    }
    return config;
  });
};
